import {URLParamBuilder} from "@/utils/functions";
import * as PATHS from "@/constants/path";
import {request} from "@/services/api/request";
import { GetCallsRequest } from "@/typings/api/calls";


type FetchCallsOptionsOptions = {
  query: GetCallsRequest["query"]
}
export function fetchCallsListRequest({query }: FetchCallsOptionsOptions) {
  const url = URLParamBuilder(PATHS.FETCH_CALLS, {
    queryString: query
  })
  return request<GetCallsRequest["response"]>(url, {
    method: 'GET'
  });
}
